import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 8px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  gap: 8px;
  min-height: 54px;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    padding: 12px;
    gap: 12px;
    min-height: 58px;
  }
`;

export const LoadingIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.black2};
  position: relative;
  flex-shrink: 0;
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.black3};
  border-top: 2px solid ${({ theme }) => theme.colors.green6};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const LoadingText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black8};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LoadingProgress = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${({ theme }) => theme.colors.black2};
  border-radius: 2px;
  overflow: hidden;
`;

export const LoadingProgressBar = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: ${({ theme }) => theme.colors.green6};
  border-radius: 2px;
  transition: width 0.3s ease;
`;
